import { render, staticRenderFns } from "./SlidingBanners.vue?vue&type=template&id=427ae68d&scoped=true"
import script from "./SlidingBanners.vue?vue&type=script&lang=ts"
export * from "./SlidingBanners.vue?vue&type=script&lang=ts"
import style0 from "./SlidingBanners.vue?vue&type=style&index=0&id=427ae68d&prod&lang=scss&scoped=true"
import style1 from "./SlidingBanners.vue?vue&type=style&index=1&id=427ae68d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ae68d",
  null
  
)

export default component.exports